export default {
  // set API endpoint
  API_URL: '/server/api/'
}
